<app-header></app-header>
<div class="bg-grey pt-5">
    <div class="container mt-5">
        <div class="row">
            <div class="col-md-6">
                <h3 class="text-orange mb-3">Contact us.</h3>
                <div class="row">
                    <div class="col-md-6">
                        <p class="mb-3"><strong>NAPERVILLE</strong></p>
                        <p class="text-nowrap">
                            1755 Park St, Suite #200,<br>
                            Naperville IL 60563
                        </p>
                    </div>
                    <div class="col-md-6">
                        <p class="mb-3"><strong>INDIA</strong></p>
                        <p class="mb-3"><strong>Gurugram</strong></p>
                        <p class="text-nowrap">
                            9th Floor, Tower-B, SAS Towers, Medicity,<br>
                            Sector 38, Gurugram, Haryana - 122002
                        </p>
                        <p class="mb-3"><strong>Bengaluru</strong></p>
                        <p class="text-nowrap">
                            CHBS Layout, Stage 2, Vijayanagar,<br>
                            Bengaluru, Karnataka 560040
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-10">
                        <h3 class="text-orange mb-3">Get in Touch</h3>
                        <div class="container p-md-0">
                            <div class="row justify-content-center">
                                <div class="col form-bg bg-white p-4 mt-2 mb-5">
                                    <form>
                                        <div class="row">
                                            <div class="col-md-6 mb-4">
                                                <select [(ngModel)]="purpose" name="purpose" #purposeref="ngModel" required
                                                    class="custom-select custom-select-lg" placeholder="your Purpose*">
                                                    <option value="">Select you Purpose*</option>
                                                    <option value="Partnership Request">Partnership Request</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                                <div *ngIf="purposeref.invalid && ( purposeref.touched) || showValidations " class="alert">
        
                                                    <div *ngIf="purposeref.errors?.required">
                                                        <span> Purpose is required.</span>
                                                    </div>
                                                </div>
                                            </div>
        
        
                                            <div class="col-md-6 mb-4">
                                                <input [(ngModel)]="name" name="name" class="search form-control pl-3"
                                                    type="text" placeholder="Name*" #nameref="ngModel" required>
                                                <div *ngIf="nameref.invalid && ( nameref.touched) || showValidations" class="alert">
        
                                                    <div *ngIf="nameref.errors?.required">
                                                        <span class="error"> Name is required.</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 mb-4">
                                                <input [(ngModel)]="email" name="email" class="search form-control pl-3"
                                                    type="text" placeholder="Email*" required #emailref="ngModel">
                                                    <div *ngIf="emailref.invalid && ( emailref.touched) || showValidations" class="alert">
        
                                                        <div *ngIf="emailref.errors?.required">
                                                            <span> Email is required.</span>
                                                        </div>
                                                    </div>
                                            </div>
                                            <div class="col-md-6 mb-4">
                                                <input [(ngModel)]="contact" name="contact" class="search form-control pl-3"
                                                    type="text" placeholder="Contact Number">
                                                    
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 mb-4">
                                                <textarea [(ngModel)]="msg" name="msg" class="form-control search" rows="2"
                                                    placeholder="Message"></textarea>
                                                    
                                            </div>
        
                                        </div>
                                        <p class="small mt-2">By activating this benefit, you agree to abide by Omni's <a
                                                href="https://app.omnicoe.com/tnc" target="_blank" class="active">terms of use</a> and <a  target="_blank" href="https://app.omnicoe.com/tnc" class="active">privacy
                                                policy</a>.</p>
                                        <div class="pt-4">
                                            <a (click)="postContactUsForm()" target="_blank"
                                                class="bg-button btn btn-primary bd-highlight text-white">Submit</a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>

<div class="modal fade" id="thanks-modal" tabindex="-1" role="dialog" aria-labelledby="thanks-modal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <h5 class="modal-title h3">Thank You</h5>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary border-button" data-dismiss="modal">Ok</button>
            </div>
        </div>
    </div>
</div>